import type {
  GetClubTournamentsStructuresResponse,
  HgClubInfo
} from '@ps/web-shared-api-types/v0/SwHomeGames';
import { noop } from 'lodash';
import React from 'react';

import type { CreateModalLocationState } from '../../../types/common';

export interface TournamentContextState extends HgClubInfo {
  activePage: number;
  title: string;
  subTitle: string;
  isRecurrenceOpen: boolean;
  isAdvancedOptionsOpen: boolean;
  loading: boolean;
  widgetId?: string;
  widgetSelect?: CreateModalLocationState['widgetSelect'];
  widgetDispatch?: CreateModalLocationState['widgetDispatch'];
  error?: string;
  tournamentStructures?: GetClubTournamentsStructuresResponse;
  noGames?: boolean;
}

export interface ContextProvider {
  state: TournamentContextState;
  setState: React.Dispatch<React.SetStateAction<TournamentContextState>>;
}

const CreateTournamentContext = React.createContext<ContextProvider>({
  state: {
    activePage: 0,
    clubId: 0,
    title: '',
    subTitle: '',
    isRecurrenceOpen: false,
    isAdvancedOptionsOpen: false,
    loading: false
  },
  setState: () => noop
});

export default CreateTournamentContext;
